import { gql } from '@apollo/client';

export const GENERATE_PICKUP_APPOINTMENT_DOWNLOAD_REPORT = gql`
    query GeneratePickupAppointmentDownloadReport(
        $filters: PickupAppointmentFiltersTypeInput!
        $timezone: String
    ) {
        generatePickupAppointmentDownloadReport(
            filters: $filters
            timezone: $timezone
        )
    }
`;
